export interface ProductTypeSupplier {
  id: string;
  productTypeId: string;
  productTypeDescription: string;
  supplierId: string;
  supplierKey: string;
  supplierName: string;
}
